import * as React from "react";
import { Formik, Form, Field } from "formik";
import styled from "styled-components";
import { Row, Col, Input } from "components/bootstrap";
import { FormSubmit } from "components/common";
import Team from "../../logic/Team";
const Container = styled.div`
  padding: 15px;
`;
const TeamQuickCreate = ({ onClose, onSubmit }) => {
  const _onSubmit = ({ name, description }, { resetForm }) => {
    const newTeam = Team.builder().name(name).description(description).build();
    return onSubmit(newTeam).then(() => {
      resetForm();
      onClose();
    });
  };
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Formik, { onSubmit: _onSubmit, initialValues: { name: "", description: "" } }, ({ isSubmitting, isValid }) => /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(Field, { name: "name" }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "name",
      label: "Name",
      required: true,
      maxLength: 200,
      onChange,
      help: "A unique name for the team",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      value
    }
  )), /* @__PURE__ */ React.createElement(Field, { name: "description" }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "description",
      label: "Description",
      required: true,
      onChange,
      help: "A description about the team",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      value
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 9, xsOffset: 3 }, /* @__PURE__ */ React.createElement(
    FormSubmit,
    {
      isSubmitting,
      isAsyncSubmit: true,
      onCancel: onClose,
      disabledSubmit: !isValid,
      submitButtonText: "Create team",
      submitLoadingText: "Creating Team"
    }
  ))))));
};
export default TeamQuickCreate;
